import React, { useState } from 'react';
import './Fruits.css';

// Import images for fruits
// import appleImage from './images/apple.jpg';
// import bananaImage from './images/banana.jpg';
// import orangeImage from './images/orange.jpg';
// import grapesImage from './images/grapes.jpg';
// import mangoImage from './images/mango.jpg';
// import pineappleImage from './images/pineapple.jpg';
// import strawberryImage from './images/strawberry.jpg';
// import blueberryImage from './images/blueberry.jpg';
// import watermelonImage from './images/watermelon.jpg';
// import kiwiImage from './images/Kiwi.jpg';

const fruits = [
  { name: ' Small Minded', image: 'Small Minded', mind:' Limited or narrow perspective; often focuses on petty details or minor issues.Tends to be judgmental and resistant to change; may hold onto grudges or focus on trivial matters.' },
  { name: ' Open Minded', image: 'Open Minded', mind:'Willingness to consider new ideas and experiences; receptive to different viewpoints.' },
  { name: ' Fixed Minded', image: 'Fixed Minded', mind:' Believes abilities and intelligence are static and unchangeable.Avoids challenges, gives up easily, and is afraid of failure.Listens without immediate judgment, seeks to understand others, and embraces change.' },
  { name: ' Growth Minded', image: 'Growth Minded', mind:' Believes abilities and intelligence can be developed through effort and learning.Embraces challenges, persists despite setbacks, and learns from criticism.' },
  { name: ' Broad-Minded', image: 'Broad Minded', mind:' Open to a wide range of ideas, cultures, and experiences; thinks globally.Embraces diversity, seeks out new knowledge, and is tolerant of differences.' },
  { name: ' Creative-Minded', image: 'Creative-Minded', mind:'Focuses on innovation and original thinking.Thinks outside the box, generates new ideas, and solves problems creatively. ' },
  { name: ' Analytical-Minded', image: 'Analytical-Minded', mind:' Focuses on logical reasoning and data-driven decisions. Examines facts and figures, applies critical thinking, and evaluates options carefully.' },
  { name: ' Empathetic-Minded', image: 'Empathetic-Minded', mind:' Highly attuned to the feelings and perspectives of others. Demonstrates compassion, listens actively, and offers support.' },
  //   { name: 'Orange', image: orangeImage },
//   { name: 'Grapes', image: grapesImage },
//   { name: 'Mango', image: mangoImage },
//   { name: 'Pineapple', image: pineappleImage },
//   { name: 'Strawberry', image: strawberryImage },
//   { name: 'Blueberry', image: blueberryImage },
//   { name: 'Watermelon', image: watermelonImage },
//   { name: 'Kiwi', image: kiwiImage }
];

const Mind = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.mind);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct fruit was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Learn Different Kind of Minded people</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box1"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image} alt={fruit.name} className="fruit-image1" />
            <p>{fruit.name}</p>
           
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}--{selectedFruit.mind}</div>}
      {/* <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizFruit ? (
          <div>
            <p>What fruit is this?</p>
            <img src={quizFruit.image} alt="Quiz Fruit" className="quiz-image" />
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter fruit name"
            />
            <button onClick={submitQuiz}>Submit</button>
            <button onClick={nextQuiz}>Next Fruit</button>
            <button onClick={clearQuiz}>Clear</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
        )}
      </div> */}
      <h1>Find-out here, which minded you are...</h1>
    </div>
  );
};

export default Mind;



